module.exports = __webpack_public_path__ + "e2e54f1fc79422edb9ac2a97074b8326.jpg";